<template><div><h2 id="truncate" tabindex="-1" class="d-docsite--header-2">Truncate <a class="header-anchor d-link d-docsite--link d-link" href="#truncate" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-truncate</code> to truncate an element's text to a single line with an ellipsis (<code v-pre>...</code>) if needed. Note that while CSS Utilities are fundamentally a single CSS property, this utility combines three: <code v-pre>overflow</code>, <code v-pre>text-overflow</code>, and <code v-pre>white-space</code> to achieve the effect.</p>
<code-example source-code='&lt;div class=&quot;d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500&quot;&gt;
  &lt;p class=&quot;d-truncate&quot;&gt;Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiisitaquequodpraesentiumexplicaboincidunt? Dolores beatae nam at sed dolorum ratione dolorem nisi velit dolor.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500">
  <p class="d-truncate">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiisitaquequodpraesentiumexplicaboincidunt? Dolores beatae nam at sed dolorum ratione dolorem nisi velit dolor.</p>
</div>
</code-example>
<h2 id="ellipsis" tabindex="-1" class="d-docsite--header-2">Ellipsis <a class="header-anchor d-link d-docsite--link d-link" href="#ellipsis" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-to-ellipsis</code>, combined with <code v-pre>d-of-hidden</code> to truncate an element's overflowing text with an ellipsis (<code v-pre>...</code>) if needed.</p>
<code-example source-code='&lt;div class=&quot;d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500&quot;&gt;
  &lt;p class=&quot;d-of-hidden d-to-ellipsis&quot;&gt;Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiisitaquequodpraesentiumexplicaboincidunt? Dolores beatae nam at sed dolorum ratione dolorem nisi velit dolor.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500">
  <p class="d-of-hidden d-to-ellipsis">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiisitaquequodpraesentiumexplicaboincidunt? Dolores beatae nam at sed dolorum ratione dolorem nisi velit dolor.</p>
</div>
</code-example>
<h2 id="clip" tabindex="-1" class="d-docsite--header-2">Clip <a class="header-anchor d-link d-docsite--link d-link" href="#clip" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-to-clip</code> to clip an element's overflowing text if needed.</p>
<code-example source-code='&lt;div class=&quot;d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500&quot;&gt;
  &lt;p class=&quot;d-of-hidden d-to-clip&quot;&gt;Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiisitaquequodpraesentiumexplicaboincidunt? Dolores beatae nam at sed dolorum ratione dolorem nisi velit dolor.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500">
  <p class="d-of-hidden d-to-clip">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiisitaquequodpraesentiumexplicaboincidunt? Dolores beatae nam at sed dolorum ratione dolorem nisi velit dolor.</p>
</div>
</code-example>
<!-- To add: Line Clamp -->
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr>
        <th scope="row" class="d-code--sm d-docsite-code">.d-truncate</th>
        <td class="d-code--sm">
          overflow: hidden !important;<br/>
          text-overflow: ellipsis !important;<br/>
          white-space: nowrap !important;
        </td>
      </tr>
      <tr v-for="i in ['ellipsis', 'clip', 'unset']">
        <th scope="row" class="d-code--sm d-docsite-code">.d-to-{{ i }}</th>
        <td class="d-code--sm">text-overflow: {{ i }} !important;</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


